// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2H0If","vector":"Logo_vector__1AiZf"};